import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  bgColor?: 'warmWhite' | 'cream';
}
export function SectionWrapper({
  children,
  className = '',
  bgColor = 'warmWhite'
}: SectionWrapperProps) {
  const bgClass = bgColor === 'cream' ? 'bg-cream' : 'bg-warmWhite';
  return <section className={`w-full py-8 md:py-12 px-4 ${bgClass} ${className}`} data-id="element-265">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-2xl mx-auto" data-id="element-266">
        {children}
      </motion.div>
    </section>;
}